
import { isMobileDevice } from "./utils";
import { testFrankApiConnection } from "./apiTester";

/**
 * Handles specific error types from Frank API requests
 */
export const handleSpecificErrors = async (error: Error, isMobile: boolean, apiUrl: string): Promise<Error> => {
  // Special handling for mobile network errors
  if (isMobile && (error instanceof TypeError && error.message === "Failed to fetch")) {
    console.log("Mobile network error detected");
    return new Error("Network error on mobile device. Please check your connection and try again.");
  }
  
  // Check if it's a CORS issue
  if (error instanceof TypeError && error.message === "Failed to fetch") {
    // Attempt a workaround by trying simple GET request to test connectivity
    const testResult = await testFrankApiConnection(apiUrl);
    if (!testResult.ok) {
      console.log("Connectivity test failed:", testResult.statusText);
      return new Error(`Cannot connect to Frank API (${testResult.statusText}). Please check the API URL in settings and ensure the service is running.`);
    }
  }
  
  return error;
};

/**
 * Detailed logging for errors
 */
export const logDetailedError = (error: any): void => {
  console.error("Error asking Frank (detailed):", {
    name: error instanceof Error ? error.name : "Unknown",
    message: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack : "No stack trace",
    type: Object.prototype.toString.call(error)
  });
};

/**
 * Logs fetch error details
 */
export const logFetchError = (fetchError: any): void => {
  console.error("Fetch error details:", {
    name: fetchError instanceof Error ? fetchError.name : "Unknown",
    message: fetchError instanceof Error ? fetchError.message : String(fetchError),
    stack: fetchError instanceof Error ? fetchError.stack : "No stack trace"
  });
};
